import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps from '../../application/core/DispatchProps';
import { default as ApplicationState } from '../../application/core/State';
import Estimations, { getArticlesEstimations } from '../../domain/estimations/Estimations';
import Footer from '../Footer';
import getEstimationsDetails, { EstimationDetails } from '../../application/estimations/getEstimationsDetails';
import PlaceEstimationRequested from '../../application/estimations/events/EstimationPlaceRequested';
import EstimationsDraftSaveRequested from '../../application/estimations/events/EstimationsDraftSaveRequested';
import EstimationPeriod from '../../domain/EstimationPeriod';
import { Month, monthByNumber } from '../admin/getEstimationMonths';
import containsAtLeastOneNotSavedEstimation from '../../domain/estimations/containsAtLeastOneNotSavedEstimation';
import Tooltip from '../tooltip/Tooltip';
import Checkbox from '../common/Checkbox';
import TermsRequested from 'src/application/estimations/events/TermsRequested';
import { PlacingEstimationStatus } from '../../application/estimations/State';
import { formatPrice } from '../formatNumber';

interface StateProps {
    estimations: Estimations;
    placedEstimations: Estimations;
    estimationPeriod: EstimationPeriod;
    isPlaceEstimationEnabled: boolean;
    discountRate: number;
    placingEstimationStatus: PlacingEstimationStatus;
}

interface State {
    isChecked: boolean;
}

class EstimationsFooter extends React.PureComponent<StateProps & DispatchProps, State> {
    constructor(props: StateProps & DispatchProps) {
        super(props);
        this.state = {
            isChecked: false
        };
    }

    public render(): JSX.Element {
        return (
            <Footer
                class="footer-container-estimations"
                details={this.renderEstimationDetails()}
                buttons={this.renderEstimationsButtons()}
                terms={this.renderTerms()}
            />
        );
    }

    private renderTerms = (): JSX.Element => {
        const onTermsClick = (): void => this.props.dispatch(new TermsRequested());
        return (
            <div className="footer-terms-wrapper">
                <div>
                    <Checkbox onChange={this.onCheckboxChange} />
                </div>
                <div className="footer-terms-text">
                    I accept
                    <button onClick={onTermsClick}>estimation terms</button>
                </div>
            </div>
        );
    };

    private renderEstimationDetails = (): JSX.Element => {
        return (
            <div className="estimation-details">
                {this.props.estimationPeriod.months.map((month: Month) => {
                    const estimation: EstimationDetails = getEstimationsDetails(getArticlesEstimations(this.props.estimations, month));
                    return (
                        <span key={month.month + month.year}>
                            <span className="details-month details-month-estimations">{`${monthByNumber[month.month]}:`}</span>
                            {`${estimation.pcs} PCS / €${formatPrice(estimation.totalPrice)}`}
                        </span>
                    );
                })}
            </div>
        );
    };

    private renderEstimationsButtons = (): JSX.Element => {
        const validationStatus = this.getValidationStatus();
        return (
            <div>
                <Tooltip enabled={validationStatus.message.length > 0} message={validationStatus.message}>
                    <button
                        disabled={validationStatus.message !== ''}
                        className={validationStatus.buttonClass}
                        onClick={this.onPlaceEstimationRequested}
                    >
                        Place estimation
                    </button>
                </Tooltip>
                <button className="buttons-draft link-button" onClick={this.onSaveEstimationsDraftRequested}>
                    Save draft
                </button>
            </div>
        );
    };

    private getValidationStatus(): { message: string; buttonClass: string } {
        if (!containsAtLeastOneNotSavedEstimation(this.props.estimations, this.props.placedEstimations) && this.state.isChecked) {
            return {
                message: 'At least one product must be estimated before placing estimation',
                buttonClass: 'buttons-save disabled'
            };
        } else if (!this.state.isChecked) {
            return {
                message: 'Please accept terms',
                buttonClass: 'buttons-save disabled'
            };
        } else if (this.props.placingEstimationStatus === PlacingEstimationStatus.Progress) {
            return {
                message: 'Processing...',
                buttonClass: 'buttons-save disabled'
            };
        }
        return { message: '', buttonClass: 'buttons-save' };
    }

    private onSaveEstimationsDraftRequested = (): void => {
        this.props.dispatch(new EstimationsDraftSaveRequested());
    };

    private onPlaceEstimationRequested = (): void => {
        this.props.dispatch(new PlaceEstimationRequested());
    };

    private onCheckboxChange = (isChecked: boolean): void => {
        this.setState({ isChecked });
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    estimations: state.estimations.estimations,
    placedEstimations: state.estimations.placedEstimations,
    estimationPeriod: state.admin.estimationPeriod!,
    isPlaceEstimationEnabled: containsAtLeastOneNotSavedEstimation(state.estimations.estimations, state.estimations.placedEstimations),
    discountRate: state.user.discountRate,
    placingEstimationStatus: state.estimations.placingEstimationStatus
});

export default connect(mapStateToProps)(EstimationsFooter);



// WEBPACK FOOTER //
// ./src/view/estimations/EstimationsFooter.tsx